/* eslint-disable */
export const printANSI = () => {
  let text = `
  ___  _____ _____ ____  _____ 
 / _ \|_   _|_   _|  _ \| ____|
| | | | | |   | | | |_) |  _|  
| |_| | | |   | | |  __/| |___ 
 \___/  |_|   |_| |_|   |_____|
                                
 :: OTCPE ::        (v2.4.0.RELEASE)

`

  console.log(`%c${text}`, 'color: #fc4d50')

  console.log('%cThanks for using Otcpe!', 'color: #fff; font-size: 14px; font-weight: 300; text-shadow:#000 1px 0 0,#000 0 1px 0,#000 -1px 0 0,#000 0 -1px 0;')

}
